/* eslint-disable @typescript-eslint/no-magic-numbers */
interface IRes {
  day: number | string;
  hour: number | string;
  minute: number | string;
  second: number | string;
  msecond: number | string;
  total_hour: number | string;
}
// 比较时间戳相距时间
export function diffTime(
  startTime = Number(new Date()),
  endTime = Number(new Date())
) {
  if (startTime >= endTime) {
    return {
      day: '00',
      hour: '00',
      minute: '00',
      second: '00',
      total_hour: '00',
      msecond: '00',
      stopFlag: true,
    };
  }

  const time = endTime - startTime;

  // 毫秒数
  const s = 1000;
  const m = s * 60;
  const h = m * 60;
  const d = h * 24;

  let day: number | string = Math.floor(time / d);
  let hour: number | string = Math.floor((time % d) / h);
  let minute: number | string = Math.floor((time % h) / m);
  let second: number | string = Math.floor((time % m) / s);
  let msecond: number | string = Math.floor(time % s);
  let total_hour: number | string = day <= 0 ? hour : day * 24 + hour;

  if (day < 10) {
    day = '0' + day;
  }
  if (hour < 10) {
    hour = '0' + hour;
  }
  if (minute < 10) {
    minute = '0' + minute;
  }
  if (second < 10) {
    second = '0' + second;
  }
  if (!msecond) {
    msecond = 0;
  }
  if (total_hour < 10) {
    total_hour = '0' + total_hour;
  }

  return {
    day,
    hour,
    minute,
    second,
    msecond,
    total_hour,
  };
}

export function secondToHour(secNum: number) {
  if (Number(secNum) <= 0) {
    return {
      day: '00',
      hour: '00',
      minute: '00',
      second: '00',
      total_hour: '00',
      msecond: '00',
      stopFlag: true,
    };
  }

  const time = Number(secNum);

  // 毫秒数
  const s = 1;
  const m = s * 60;
  const h = m * 60;
  const d = h * 24;

  let day: number | string = Math.floor(time / d);
  let hour: number | string = Math.floor((time % d) / h);
  let minute: number | string = Math.floor((time % h) / m);
  let second: number | string = Math.floor((time % m) / s);
  let msecond: number | string = Math.floor(time % s);
  let total_hour: number | string = day <= 0 ? hour : day * 24 + hour;

  if (day < 10) {
    day = '0' + day;
  }
  if (hour < 10) {
    hour = '0' + hour;
  }
  if (minute < 10) {
    minute = '0' + minute;
  }
  if (second < 10) {
    second = '0' + second;
  }
  if (!msecond) {
    msecond = 0;
  }
  if (total_hour < 10) {
    total_hour = '0' + total_hour;
  }

  return {
    day,
    hour,
    minute,
    second,
    msecond,
    total_hour,
  };
}

// 倒计时
export function countTime(
  config: { endTime: number; interval: number },
  cb: (obj: IRes) => any
) {
  class Timer {
    private startTime: number | null = null;
    private endTime: number | null = null;
    private interval = 1000;
    private cb: (res: IRes) => any = () => { };
    private timer: any = null;
    private stopFlag = false;
    private countIndex = 0;
    private deviation = 0;

    constructor(
      { endTime = new Date().getTime(), interval = 1000 },
      cb: (res: IRes) => void
    ) {
      this.endTime = endTime;
      this.interval = interval;
      this.cb = cb;

      this.timer = null;
      this.stopFlag = false;

      this.start();
    }

    public start(): boolean | void {
      if (this.timer) {
        return false;
      }

      this.countIndex = 0;
      this.deviation = 0;
      this.stopFlag = false;
      this.startTime = Number(new Date());
      this.loop();
    }

    public loop(): boolean | void {
      if (this.stopFlag) {
        return false;
      }

      this.timer = setTimeout(() => {
        const nowTime = Number(new Date());
        this.countIndex++;

        this.deviation =
          nowTime -
          ((this.startTime as number) + this.countIndex * this.interval);

        const res: IRes = diffTime(nowTime, this.endTime as number);

        this.cb && this.cb(res);
        if (this.stopFlag) {
          this.stop();
        } else {
          this.loop();
        }
      }, this.interval - this.deviation);
    }

    public stop() {
      this.stopFlag = true;
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  return new Timer(config, cb);
}
